export const detectUriTextMixin = {
  data: function() {
    return {
      URLMatcher: /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim,
      mailMatcher: /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\-\_]+?(\.[a-zA-Z]{2,6})+)/gim
    };
  },

  methods: {
    detectUriTextMixin(text: string) {
      if (text) {
        var withLinks = text.replace(
          this.URLMatcher,
          match => `<a href="${match}" target="_blank">${match}</a>`
        );

        withLinks = withLinks.replace(
          this.mailMatcher,
          '<a href="mailto:$1">$1</a>'
        );

        return withLinks;
      }
      return text;
    }
  }
};
